import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";
import LoginActivityAlert from "@/components/LoginActivityAlert";
import { Truck, Package, Users, Wallet, Banknote, AlertCircle, Boxes, Inbox, Target, TrendingUp } from "lucide-react";

function Kpi({ label, value, icon: Icon, tone = "text-primary", suffix = "" }) {
  return (
    <div className="surface-card p-5" data-testid={`distkpi-${label.toLowerCase().replace(/\s+/g,"-")}`}>
      <div className="flex items-center justify-between"><span className="label-overline">{label}</span><Icon className={`w-4 h-4 ${tone}`} /></div>
      <div className="font-display text-2xl sm:text-3xl font-black mt-3">{value ?? "—"}{suffix && <span className="text-sm font-bold text-muted-foreground ml-1">{suffix}</span>}</div>
    </div>
  );
}

export default function Dashboard() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [k, setK] = useState(null);
  useEffect(() => { api.get("/distributor/kpis").then(({ data }) => setK(data)); }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 sm:space-y-8" data-testid="distributor-dashboard">
      <div>
        <div className="label-overline">Regional distribution</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black mt-2">{t("dashboards.distributor.welcome", { name: user?.full_name?.split(" ")[0] || "Distributor" })}</h1>
        <p className="text-muted-foreground mt-2">{t("dashboards.distributor.subtitle")}</p>
      </div>

      <LoginActivityAlert />

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Kpi label="Today's orders" value={k?.todays_orders} icon={Inbox} />
        <Kpi label="Pending orders" value={k?.pending_orders} icon={Package} tone="text-amber-600" />
        <Kpi label="Shipments in transit" value={k?.shipments_in_transit} icon={Truck} tone="text-violet-600" />
        <Kpi label="Monthly sales" value={`₹${(k?.monthly_sales || 0).toLocaleString()}`} icon={Banknote} tone="text-emerald-700" />
        <Kpi label="Outstanding" value={`₹${(k?.outstanding || 0).toLocaleString()}`} icon={Wallet} tone="text-amber-700" />
        <Kpi label="Regional revenue (MTD)" value={`₹${(k?.regional_revenue || 0).toLocaleString()}`} icon={TrendingUp} tone="text-emerald-700" />
        <Kpi label="Target achievement" value={k?.target_achievement_pct ?? 0} suffix="%" icon={Target} tone="text-violet-700" />
        <Kpi label="Available inventory (SKUs)" value={k?.available_inventory} icon={Boxes} />
        <Kpi label="Low-stock alerts" value={k?.low_stock_alerts} icon={AlertCircle} tone="text-red-600" />
        <Kpi label="Returns pending" value={k?.returns_pending} icon={Inbox} tone="text-amber-600" />
        <Kpi label="Monthly target" value={`₹${(k?.monthly_target || 0).toLocaleString()}`} icon={Target} />
      </div>
    </div>
  );
}
